import React, { useState } from 'react';

import { LocateProductPart } from '@apis/manageInventory/LocateProduct.type';
import { Table as AntTable } from '@atoms/table/Table';
import { ToolTip } from '@atoms/tooltip/ToolTip';
import sslsTableStyles from '@organisms/locateProducts/SslsTable.module.less';
import { SvgInfo } from 'components/icons';

export interface PartsTableProps {
    locateProductParts: LocateProductPart[];
}

const columns = [
    {
        title: 'Product',
        dataIndex: 'product',
        key: 'product'
    },
    {
        title: 'On Hand',
        dataIndex: 'goodProductQty',
        key: 'goodProductQty'
    },
    {
        title: 'Bad On Hand',
        dataIndex: 'badProductQty',
        key: 'badProductQty'
    }
];

export const PartsTable = ({ locateProductParts }: PartsTableProps) => {
    const [expandedRowId, setExpandedRowId] = useState('');

    const parts = locateProductParts.map((part) => {
        const substituteParts = part.substituteItemList.map(
            (sub) => sub.clientSubstituteItemId
        );

        const tooltipText =
            substituteParts.length === 1
                ? `Substitute product for ${substituteParts[0]}`
                : substituteParts.length > 1
                ? `Substitute product for ${substituteParts.join(
                      ', '
                  )} requested products`
                : null;
        return {
            id: part.clientItemId,
            ...part,
            product: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {part.clientItemId}&nbsp;
                    {tooltipText && (
                        <ToolTip
                            title={tooltipText}
                            placement="bottom"
                            data-testid="watchlist-tooltip"
                            regularDisplayMode={true}
                        >
                            <SvgInfo data-testid="watchlist-tooltip-icon" />
                        </ToolTip>
                    )}
                </div>
            )
        };
    });

    return (
        <AntTable
            columns={columns}
            dataSource={parts}
            isLoading={false}
            expandable={{
                rowExpandable: (record) => record.serialList.length > 0,
                expandedRowRender: () => '',
                onExpand: (_, row) =>
                    expandedRowId === row.id
                        ? setExpandedRowId('')
                        : setExpandedRowId(row.id),
                expandedRowKeys: [expandedRowId]
            }}
            expandClassName={sslsTableStyles.ExpandIcon}
        ></AntTable>
    );
};
